// extracted by mini-css-extract-plugin
export var parcelRow = "_un-0";